import { Tooltip, IconButton } from "@mui/material";
import BodySmallRegular from "../designSystem/BodySmallRegular";
import Loader from "../subComponents/Loader";
import BodySmallMedium from "../designSystem/BodySmallMedium";

const DynamicTable = ({
  data,
  isLoading,
  columns,
  permissions,
  actions,
}) => {
  console.log("data", data)
  console.log("isLoading", isLoading)
  console.log("columns", columns)
  console.log("permissions", permissions)
  console.log("actions", actions)
  return (
    <div className="dynamic-table-container">
      <table>
        <thead>
          <tr>
            {columns?.map((col, index) => (
              <th key={index}>
                <div className="header-with-icon">
                <BodySmallMedium text={col.label} color="#1E293B" />
                  {/* <img
                    src={thIcon}
                    alt={`${col.label} Icon`}
                    style={{ width: "16px", height: "16px", marginRight: "8px" }}
                  /> */}
                </div>
              </th>
            ))}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={columns?.length + 1} style={{ textAlign: "center" }}>
                <Loader colored={true} />
              </td>
            </tr>
          ) : data?.length === 0 ? (
            <tr>
              <td colSpan={columns?.length + 1} style={{ textAlign: "center" }}>
                No data found
              </td>
            </tr>
          ) : (
            data?.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns?.map((col, colIndex) => (
          <td
          key={colIndex}
          style={
            ["description", "rankDescription","address"].includes(col.accessor)
              ? { maxWidth: "40%", width: "40%", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }
              : {}
          }
        >
          {["description", "rankDescription","address"].includes(col.accessor) ? (
            row[col.accessor]?.length > 60 ? (
              <Tooltip title={row[col.accessor]} arrow>
                <span>
                  <BodySmallRegular text={`${row[col.accessor]?.substring(0, 60)}...`} color="#1E293B" />
                </span>
              </Tooltip>
            ) : (
              <BodySmallRegular text={row[col.accessor]} color="#1E293B" />
            )
          ) : (
            <BodySmallRegular text={row[col.accessor]} color="#1E293B" />
          )}
        </td>
        
          
               
                ))}
                <td>
                  {actions?.map((action, actionIndex) => {
                    if (action.type === "handle") {
                      return (
                        <Tooltip key={actionIndex} title={action.label} arrow>
                          <IconButton onClick={() => action.linkTo(row)}>
                            {action.icon}
                          </IconButton>
                        </Tooltip>
                      );
                    }
                    if (permissions && permissions.includes(action.permission)) {
                      return (
                        <Tooltip key={actionIndex} title={action.label} arrow>
                          <IconButton onClick={() => action.handler(row)}>
                            {action.icon}
                          </IconButton>
                        </Tooltip>
                      );
                    } else {
                      return null;
                    }
                  })}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DynamicTable;
